<script setup lang="ts">
/**
 * Статус мероприятия.
 *
 * Цвета не выстраиваются в «шкалу прогресса» намеренно: переходы между
 * статусами на сервере ничем не ограничены, любой можно поставить любым, и
 * визуальный порядок обещал бы жизненный цикл, которого нет. «Отменено»
 * выделено разрушающим вариантом — это единственный статус, о котором важно
 * узнать с одного взгляда, не читая.
 */
import { computed } from 'vue'
import type { BadgeVariants } from '@/components/ui/badge'
import { Badge } from '@/components/ui/badge'
import { EVENT_STATUS_LABELS } from '@/types/api'

const props = defineProps<{
  status: string
}>()

const VARIANTS: Record<string, BadgeVariants['variant']> = {
  EVENT_STATUS_PLANNED: 'secondary',
  EVENT_STATUS_IN_PROGRESS: 'default',
  EVENT_STATUS_COMPLETED: 'outline',
  EVENT_STATUS_CANCELLED: 'destructive',
}

const view = computed(() => {
  const label = EVENT_STATUS_LABELS[props.status as keyof typeof EVENT_STATUS_LABELS]
  return label && props.status !== 'EVENT_STATUS_UNSPECIFIED'
    ? { label, variant: VARIANTS[props.status] }
    : { label: props.status, variant: 'outline' as const }
})
</script>

<template>
  <Badge :variant="view.variant">
    {{ view.label }}
  </Badge>
</template>
